module.exports = __webpack_public_path__ + "static/media/searchCloud.d504450b.svg";